const TOOLTIP_WORD_LENGTH = 25;
export const useChartWidget = () => {

    // TODO: Fix to not use DOM manipulation
    // Legend title formatter
    // Based on chart is unreliable because it'll be null be resizing. Therefore, based on parent
    // chartArea present then calculate the actual width in pixel (fontsize*0.6*char_num) then compare with the box for more suitable cutoff
    const legendTitleFormatter = (title, widgetId) => {
        if (typeof title !== 'string'){
        return title
        }
        const chartContainer = jQuery(`#${widgetId} > * .chart-container`).first()
        if (chartContainer){
        if ( chartContainer.width() < title.length * 15 * 0.6){
            return `${title.substring(0, title.lastIndexOf(' ', (chartContainer.width()/(15*0.6))+1))}...`
        }
        return title
        }
        return title
    }

    const tooltipTextFormatter = (text) => {
        const stringList = []
        while (true){
            let end = text.indexOf(" ", TOOLTIP_WORD_LENGTH);
            end = end >= 0 ? end : text.length;
            let substr = text.substring(0,end);
            stringList.push(substr)
            if (end >= text.length) {
                break;
            }
            text = text.substring(end+1);
        }
        return stringList
    }

    return {
        legendTitleFormatter,
        tooltipTextFormatter
    }
}
